import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dashboard');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dashboard/view.scss */
/* src/app/page.dashboard/view.scss: no such file or directory */`],
})
export class PageDashboardComponent implements OnInit {
    public refreshing: boolean = false;
    public activeLogFilter: string = 'all';
    public updatedAt: string = '';

    public metrics: any[] = [
        {
            id: 'transfer',
            label: '오늘 이관',
            value: '156',
            unit: '건',
            helper: '전일 대비 18.2%',
            tone: 'blue',
            link: '/migrations'
        },
        {
            id: 'success',
            label: '이관 성공률',
            value: '99.3',
            unit: '%',
            helper: '목표 대비 1.3%p 상회',
            tone: 'emerald',
            link: '/migrations'
        },
        {
            id: 'processing',
            label: '처리 중',
            value: '5',
            unit: '건',
            helper: '예상 완료 12분',
            tone: 'cyan',
            link: '/migrations'
        },
        {
            id: 'security',
            label: '보안 경고',
            value: '3',
            unit: '건',
            helper: '확인 필요',
            tone: 'rose',
            link: '/security'
        }
    ];

    public logFilters: any[] = [
        { key: 'all', label: '전체' },
        { key: 'success', label: '성공' },
        { key: 'processing', label: '진행 중' },
        { key: 'failed', label: '실패' }
    ];

    public migrationLogs: any[] = [
        {
            file: 'ETCH_CD_MEASURE_0907.xlsx',
            source: 'ETCH-12',
            target: 'CD 계측 저장소',
            rows: '24,860',
            size: '18.4 MB',
            requestedAt: '14:32:08',
            status: 'processing',
            progress: 72
        },
        {
            file: 'CMP_THICKNESS_LOT_A18.xlsx',
            source: 'CMP-07',
            target: '두께 분석 저장소',
            rows: '18,420',
            size: '12.7 MB',
            requestedAt: '14:18:42',
            status: 'success',
            progress: 100
        },
        {
            file: 'WAFER_MAP_LINE_03.xlsx',
            source: 'INSPECT-03',
            target: '수율 분석 저장소',
            rows: '32,104',
            size: '26.1 MB',
            requestedAt: '13:54:16',
            status: 'success',
            progress: 100
        },
        {
            file: 'PHOTO_OVERLAY_PM.xlsx',
            source: 'PHOTO-21',
            target: 'Overlay 저장소',
            rows: '9,845',
            size: '7.8 MB',
            requestedAt: '13:21:03',
            status: 'failed',
            progress: 38
        },
        {
            file: 'DIFFUSION_TEMP_TRACE.xlsx',
            source: 'DIFF-09',
            target: '공정 이력 저장소',
            rows: '15,220',
            size: '11.2 MB',
            requestedAt: '12:47:55',
            status: 'success',
            progress: 100
        }
    ];

    public securityAlerts: any[] = [
        {
            severity: 'critical',
            type: '경로 노출',
            title: '허용되지 않은 공유 경로 감지',
            description: '\\\\fab-share\\public 경로가 이관 규칙에 포함되었습니다.',
            source: 'PHOTO-21',
            time: '14:27',
            action: '경로 차단'
        },
        {
            severity: 'high',
            type: '권한 오류',
            title: '대상 저장소 쓰기 권한 거부',
            description: 'svc_migration 계정의 Overlay 저장소 권한을 확인하세요.',
            source: 'AUTH-GW',
            time: '13:22',
            action: '권한 확인'
        },
        {
            severity: 'medium',
            type: '이상 접근',
            title: '업무 시간 외 대량 다운로드',
            description: '동일 계정에서 10분 내 14개 파일 다운로드가 발생했습니다.',
            source: '10.24.18.72',
            time: '11:08',
            action: '접근 검토'
        }
    ];

    public migrationStages: any[] = [
        { label: '파일 수집', detail: '156 / 156', progress: 100, state: '완료' },
        { label: '무결성 검증', detail: '155 / 156', progress: 99, state: '정상' },
        { label: '민감정보 검사', detail: '153 / 156', progress: 98, state: '검사 중' },
        { label: '저장소 적재', detail: '151 / 156', progress: 97, state: '진행 중' }
    ];

    public equipmentStatus: any[] = [
        { name: 'ETCH', total: 12, online: 12, rate: 100 },
        { name: 'PHOTO', total: 18, online: 17, rate: 94 },
        { name: 'CMP', total: 9, online: 9, rate: 100 },
        { name: 'INSPECT', total: 14, online: 13, rate: 93 }
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.updateTimestamp();
    }

    public get visibleLogs() {
        if (this.activeLogFilter === 'all') return this.migrationLogs;
        return this.migrationLogs.filter((log: any) => log.status === this.activeLogFilter);
    }

    public filterCount(key: string) {
        if (key === 'all') return this.migrationLogs.length;
        return this.migrationLogs.filter((log: any) => log.status === key).length;
    }

    public setLogFilter(key: string) {
        this.activeLogFilter = key;
    }

    public async refreshDashboard() {
        if (this.refreshing) return;
        this.refreshing = true;
        await this.service.render();

        await new Promise(resolve => setTimeout(resolve, 450));
        this.updateTimestamp();
        this.refreshing = false;
        await this.service.render();
    }

    public statusLabel(status: string) {
        const labels: any = {
            success: '성공',
            processing: '진행 중',
            failed: '실패'
        };
        return labels[status] || status;
    }

    public statusClass(status: string) {
        const classes: any = {
            success: 'bg-emerald-50 text-emerald-700 border-emerald-200',
            processing: 'bg-blue-50 text-blue-700 border-blue-200',
            failed: 'bg-rose-50 text-rose-700 border-rose-200'
        };
        return classes[status] || 'bg-slate-50 text-slate-600 border-slate-200';
    }

    public severityClass(severity: string) {
        const classes: any = {
            critical: 'bg-rose-50 text-rose-700 border-rose-200',
            high: 'bg-amber-50 text-amber-700 border-amber-200',
            medium: 'bg-blue-50 text-blue-700 border-blue-200'
        };
        return classes[severity] || 'bg-slate-50 text-slate-600 border-slate-200';
    }

    public severityLabel(severity: string) {
        const labels: any = {
            critical: '긴급',
            high: '높음',
            medium: '주의'
        };
        return labels[severity] || severity;
    }

    private updateTimestamp() {
        this.updatedAt = new Date().toLocaleTimeString('ko-KR', {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false
        });
    }
}

export default PageDashboardComponent;